<div class="modal-header">
    <div class="title">
        <h2 class="modal-title-prefix"><span translate="SIFRAFIRMEKODKUPCA.SINGULAR"></span></h2>
    </div>
    <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
    <form [formGroup]="formGroup" class="">
    <div class="row">
        <div class="col-md-12">
            <div class="form-group row">
            <!-- <div class="form-group row" *ngIf="fcd && fcd['BrojNarudzbenice'] && fcd['BrojNarudzbenice'].IsVisible"> -->
                <div class="col-md-12">
                    <yt-input 
                        [Type]="'text'" 
                        [Label]="'KOMITENT.SIFRAFIRMEKODKUPCA.SINGULAR'"
                        formControlName="FirmaSifraKodKupca" 
                        [MaxLength]="50">
                    </yt-input>
                </div>
            </div>
        </div>
</div>
</form>
</div>
<div class="modal-footer">
    <button type="submit" class="btn btn-primary" id="btnSave" (click)="Save()"><span>Sačuvaj</span></button>
    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Zatvori</span></button>
</div>